<div class="rota-detalhes-documentos-container" [class.list-view]="viewMode === 'list'">
  <!-- Modo Lista - Tabela -->
  <div *ngIf="viewMode === 'list'" class="table-container">
    <table class="documents-table" *ngIf="(documentos$ | async)?.length">
      <thead>
        <tr>
          <th class="sortable-header" (click)="sortBy('visita')" [class.active]="sortColumn === 'visita'">
            Visita
            <mat-icon *ngIf="sortColumn === 'visita'" class="sort-icon"
                  [class.desc]="sortDirection === 'desc'">
              arrow_upward
            </mat-icon>
          </th>
          <th class="sortable-header" (click)="sortBy('tipo')" [class.active]="sortColumn === 'tipo'">
            Tipo
            <mat-icon *ngIf="sortColumn === 'tipo'" class="sort-icon"
                  [class.desc]="sortDirection === 'desc'">
              arrow_upward
            </mat-icon>
          </th>
          <th class="sortable-header" (click)="sortBy('status')" [class.active]="sortColumn === 'status'">
            Status
            <mat-icon *ngIf="sortColumn === 'status'" class="sort-icon"
                  [class.desc]="sortDirection === 'desc'">
              arrow_upward
            </mat-icon>
          </th>
          <th class="sortable-header" (click)="sortBy('registro')" [class.active]="sortColumn === 'registro'">
            Registro
            <mat-icon *ngIf="sortColumn === 'registro'" class="sort-icon"
                  [class.desc]="sortDirection === 'desc'">
              arrow_upward
            </mat-icon>
          </th>
          <th></th> <!-- Coluna para ações -->
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let referencia of (loaded$ | async) ? (documentos$ | async) : []" class="table-row">
          <td class="visita-column">
            <span class="pedido-numero">#{{referencia.pedido.ordem}}</span>
          </td>
          <td class="tipo-column">
            <span class="tipo-text">{{referencia.tipo}}</span>
            <span *ngIf="!['undefined', 'null', undefined, null].includes(referencia?.incidente?.descricao)"
                  class="incidente-text">{{referencia?.incidente?.descricao}}</span>
          </td>
          <td class="status-column">
            <app-state-circle
              [matTooltip]="referencia.statusKey | translate | uppercase"
              matTooltipPosition="above"
              [visit]="referencia.pedido.icon">
            </app-state-circle>
          </td>
          <td class="registro-column">
            <span class="data-text">{{referencia.arquivo.data | date:'dd/MM/yyyy - HH:mm:ss'}}</span>
          </td>
          <td class="actions-column">
            <div class="table-actions">
              <span
                class="action-icon download-icon"
                (click)="downloadDocument(referencia)"
                matTooltip="Baixar documento"
                matTooltipPosition="above">
                <mat-icon>download</mat-icon>
              </span>
              <span
                class="action-icon view-icon"
                (click)="openDocument(referencia)"
                matTooltip="Visualizar documento"
                matTooltipPosition="above">
                <mat-icon>open_in_new</mat-icon>
              </span>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- Modo Imagem - Cards (mantido como estava) -->
  <div *ngIf="viewMode === 'image'">
    <div class="flex fill flex-wrap ov-auto jc-space-evenly" *ngIf="((documentos$ | async)?.length || !((loaded$ | async) ?? 0))">
    <mat-card *ngFor="let referencia of (loaded$ | async) ? (documentos$ | async) : []"
              class="card mat-elevation-z1">
      <div class="card-header">
        <span class="card-text mat-h2" style="padding-right: .5rem;line-height: 22px;">
          {{referencia.tipo}}{{['undefined', 'null', undefined, null].includes(referencia?.incidente?.descricao)
          ? '' : ' ' + referencia?.incidente?.descricao}}
        </span>
        <div>
          <div class="card-text mat-h2 pedido-ordem">#{{referencia.pedido.ordem}}</div>
          <app-state-circle [matTooltip]="referencia.statusKey | translate | uppercase" matTooltipPosition="above"
            [visit]="referencia.pedido.icon">
          </app-state-circle>
        </div>
      </div>

      <div class="card-content" *ngIf="viewMode === 'image'">
        <ng-container *ngIf="(referencia.arquivo.nome.split('\.').pop() || '').toLowerCase() !== 'pdf' else ElsePDF">
          <img [src]="referencia.arquivo.linkView" alt="{{ 'ROUTE_REPORT.DOCUMENTS.RECEIPT' | translate }}"
            onerror="this.src = assetUrl('images/no_image.png')" mat-card-image>
        </ng-container>
        <ng-template #ElsePDF>
          <mat-icon class="icon-caminhao">picture_as_pdf</mat-icon>
        </ng-template>
      </div>

      <div class="card-actions">
        <div class="actions-container">
          <div class="card-text mat-h2">{{referencia.arquivo.data | date:'dd/MM/yy - HH:mm'}}</div>
          <div class="action-buttons">
            <span
              class="action-icon download-icon"
              (click)="downloadDocument(referencia)"
              matTooltip="Baixar documento"
              matTooltipPosition="above">
              <mat-icon>download</mat-icon>
            </span>
            <span
              class="action-icon view-icon"
              (click)="openDocument(referencia)"
              matTooltip="Visualizar documento"
              matTooltipPosition="above">
              <mat-icon>open_in_new</mat-icon>
            </span>
          </div>
        </div>
      </div>
    </mat-card>

    <ngx-skeleton-loader class="flex fill flex-wrap ov-auto jc-space-evenly" count="5" appearance="circle" *ngIf="!((loaded$ | async) ?? 0)"></ngx-skeleton-loader>
    </div>
  </div>

  <!-- Container vazio para ambos os modos -->
  <div *ngIf="!(documentos$ | async)?.length && ((loaded$ | async) ?? 0)" class="else-container">
    <mat-icon class="icon-caminhao">find_in_page</mat-icon>
    <span class="mat-body-2">{{ 'ROUTE_REPORT.DOCUMENTS.EMPTY_LIST' | translate }}</span>
  </div>
</div>
